import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NgScrollbarModule } from 'ngx-scrollbar';
import { CKEditorModule } from 'ng2-ckeditor';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { AngularMaterialModule } from '../angular-material/angular-material.module';

import { PipesModule } from '@app/pipes/pipes.module';
import { FilePickerModule } from '../shared/file-picker/file-picker.module';
import { GmailModule } from '../shared/gmail/gmail.module';
import { LeaderboardModule } from '../shared/leaderboard/leaderboard.module';
import { HtmlEditorModule } from '../shared/html-editor/html-editor.module';
import { SharedUserToolsModule } from '../shared/shared-user-tools/shared-user-tools.module';

import { TimeoutDialogComponent } from './timeout-dialog/timeout-dialog.component';
import { ConfirmActionDialogComponent } from './confirm-action-dialog/confirm-action-dialog.component';
import { MultiChoiceConfirmDialogComponent } from './multi-choice-confirm-dialog/multi-choice-confirm-dialog.component';
import { ModuleSearchDialogComponent } from './module-search-dialog/module-search-dialog.component';
import { CustomEmailSenderDialogComponent } from './custom-email-sender-dialog/custom-email-sender-dialog.component';
import { ModuleIconPickerComponent } from './module-icon-picker/module-icon-picker.component';
import { ChangeFieldLabelDialogComponent } from './change-field-label-dialog/change-field-label-dialog.component';
import { DocumentViewerDialogComponent } from './document-viewer-dialog/document-viewer-dialog.component';
import { MessageUserDialogComponent } from './message-user-dialog/message-user-dialog.component';
import { LibraryResourceSearchSelectComponent } from './library-resource-search-select/library-resource-search-select.component';
import { ActionProgressDialogComponent } from './action-progress-dialog/action-progress-dialog.component';
import { SystemResetConfirmationDialogComponent } from './system-reset-confirmation-dialog/system-reset-confirmation-dialog';
import { DateTimePickerDialogComponent } from './date-time-picker-dialog/date-time-picker-dialog.component';
import { AccessControlsMassUpdateDialogComponent } from './access-controls-mass-update-dialog/access-controls-mass-update-dialog.component';
import { ReportSearchSelectComponent } from './report-search-select/report-search-select.component';
import { DefaultDashboardSearchSelectComponent } from './default-dashboard-search-select/default-dashboard-search-select.component';
import { DisplayListDialogComponent } from './display-list-dialog/display-list-dialog.component';
import { LeaderboardViewerDialogComponent } from './leaderboard-viewer-dialog/leaderboard-viewer-dialog.component';
import { GameRewardsViewerDialogComponent } from './game-rewards-viewer-dialog/game-rewards-viewer-dialog.component';
import { CreditsNotificationDialogComponent } from './credits-notification-dialog/credits-notification-dialog.component';
import { NumberRangePickerDialogComponent } from './number-range-picker-dialog/number-range-picker-dialog.component';
import { RecordAmountSelectorDialogComponent } from './record-amount-selector-dialog/record-amount-selector-dialog.component';
import { VideoPlayerDialogComponent } from './video-player-dialog/video-player-dialog.component';
import { VoiceshotDialogComponent } from './voiceshot-dialog/voiceshot-dialog.component';
import { RejectionDialogComponent } from './rejection-dialog/rejection-dialog.component';
import { NameInputDialogComponent } from './name-input-dialog/name-input-dialog.component';
import { JobCampaignRerunOptionPickerComponent } from './job-campaign-rerun-option-picker/job-campaign-rerun-option-picker.component';
import { JobPersonalizedCampaignMessageDialogComponent } from './job-personalized-campaign-message-dialog/job-personalized-campaign-message-dialog.component';
import { OpenAiPromptDialogComponent } from './open-ai-prompt-dialog/open-ai-prompt-dialog.component';
import { CampaignPickerDialogComponent } from './campaign-picker-dialog/campaign-picker-dialog.component';
import { DateRangePickerDialogComponent } from './date-range-picker-dialog/date-range-picker-dialog.component';
import { BookingCancelDialogComponent } from './booking-cancel-dialog/booking-cancel-dialog.component';
import { BookingNoShowDialogComponent } from './booking-no-show-dialog/booking-no-show-dialog.component';
import { BookingHistoryDialogComponent } from './booking-history-dialog/booking-history-dialog.component';
import { ScrapedJobStatusUpdateDialogComponent } from './scraped-job-status-update-dialog/scraped-job-status-update-dialog.component';
import { BulkAgreementSendDialogComponent } from './bulk-agreement-send-dialog/bulk-agreement-send-dialog.component';

@NgModule({
    declarations: [
        TimeoutDialogComponent,
        ConfirmActionDialogComponent,
        MultiChoiceConfirmDialogComponent,
        ModuleSearchDialogComponent,
        CustomEmailSenderDialogComponent,
        ModuleIconPickerComponent,
        ChangeFieldLabelDialogComponent,
        DocumentViewerDialogComponent,
        MessageUserDialogComponent,
        LibraryResourceSearchSelectComponent,
        ActionProgressDialogComponent,
        SystemResetConfirmationDialogComponent,
        DateTimePickerDialogComponent,
        AccessControlsMassUpdateDialogComponent,
        ReportSearchSelectComponent,
        DefaultDashboardSearchSelectComponent,
        DisplayListDialogComponent,
        LeaderboardViewerDialogComponent,
        GameRewardsViewerDialogComponent,
        CreditsNotificationDialogComponent,
        NumberRangePickerDialogComponent,
        RecordAmountSelectorDialogComponent,
        VideoPlayerDialogComponent,
        VoiceshotDialogComponent,
        RejectionDialogComponent,
        NameInputDialogComponent,
        JobCampaignRerunOptionPickerComponent,
        JobPersonalizedCampaignMessageDialogComponent,
        OpenAiPromptDialogComponent,
        CampaignPickerDialogComponent,
        DateRangePickerDialogComponent,
        BookingCancelDialogComponent,
        BookingNoShowDialogComponent,
        BookingHistoryDialogComponent,
        ScrapedJobStatusUpdateDialogComponent,
        BulkAgreementSendDialogComponent
    ],
    exports: [
        TimeoutDialogComponent,
        ConfirmActionDialogComponent,
        MultiChoiceConfirmDialogComponent,
        ModuleSearchDialogComponent,
        CustomEmailSenderDialogComponent,
        ModuleIconPickerComponent,
        ChangeFieldLabelDialogComponent,
        DocumentViewerDialogComponent,
        MessageUserDialogComponent,
        LibraryResourceSearchSelectComponent,
        ActionProgressDialogComponent,
        SystemResetConfirmationDialogComponent,
        DateTimePickerDialogComponent,
        AccessControlsMassUpdateDialogComponent,
        ReportSearchSelectComponent,
        DefaultDashboardSearchSelectComponent,
        DisplayListDialogComponent,
        LeaderboardViewerDialogComponent,
        GameRewardsViewerDialogComponent,
        CreditsNotificationDialogComponent,
        NumberRangePickerDialogComponent,
        RecordAmountSelectorDialogComponent,
        VideoPlayerDialogComponent,
        VoiceshotDialogComponent,
        RejectionDialogComponent,
        NameInputDialogComponent,
        JobPersonalizedCampaignMessageDialogComponent,
        OpenAiPromptDialogComponent,
        CampaignPickerDialogComponent,
        DateRangePickerDialogComponent,
        BookingCancelDialogComponent,
        BookingNoShowDialogComponent,
        BookingHistoryDialogComponent,
        ScrapedJobStatusUpdateDialogComponent,
        BulkAgreementSendDialogComponent
    ],
    imports: [
        CommonModule,
        NgxDocViewerModule,
        NgScrollbarModule,
        AngularMaterialModule,
        PipesModule,
        GmailModule,
        FormsModule,
        FilePickerModule,
        ReactiveFormsModule,
        CKEditorModule,
        LeaderboardModule,
        HtmlEditorModule,
        SharedUserToolsModule
    ]
})
export class DialogsModule { }
